(function (angular) {
  angular
    .module("app")
    .controller("migrateController", ["$location", "$q", "_", "STATES", "migrateService", "signupService", "alkAuthenticationService", "Messages", "ALKLogin", function ($location, $q, _, STATES, migrateService, signupService, alkAuthenticationService, Messages, ALKLogin) {
      var vm = this;

      vm.states = STATES;
      vm.countries = _.uniq(STATES, "country");
      vm.wizardStep = 0;

      // handle page load and query parameters.
      vm.pcmUser = {
        username: $location.search().username,
        account: $location.search().account
      };

      vm.isSSOPasswordValid = true;

      vm.totalPrice = function () {
        var unitPrice = vm.signup.user.featureLevel === 'Standard' ? 59.99 : 84.99;
        return vm.signup.user.numberOfUsers * unitPrice;
      }

      vm.accountSelected = function (account) {
        vm.signup.user.account = account.AccountName;
        vm.signup.user.accountId = account.AccountId;
      };

      vm.toggleUseExistingAccount = function () {
        vm.enterNewAccount = !vm.enterNewAccount;

        delete vm.signup.user.account;
        delete vm.signup.user.accountId;
      };

      vm.loginToSSO = function () {
        return loginToSSO().then(getUserAccounts);
      };

      vm.notMyEmail = function () {
        vm.signup.user.ssoExists = false;

        delete vm.signup.user.password;
        delete vm.signup.user.ssoId;
        delete vm.signup.user.username;

        vm.signup.user.ssoFirstName = vm.signup.contact == null ? "" : vm.signup.contact.firstName;
        vm.signup.user.ssoLastName = vm.signup.contact == null ? "" : vm.signup.contact.lastName;

        vm.wizardStep = 2;
      };

      vm.loginToPcMiler = function () {
        vm.isProcessing = true;

        return migrateService.authenticate(vm.pcmUser).then(function (data) {
          console.log(data);
          vm.oSignup = angular.copy(data);

          pcMilerSignedIn(data);

          vm.wizardStep = (data.user.ssoExists === true) ? 1 : 2;
        }).finally(function () {
          vm.isProcessing = false;
        });
      };

      vm.deleteUser = function (user) {
        var indexOf = vm.signup.user.subUsers.indexOf(user);
        if (indexOf >= 0) {
          vm.signup.user.subUsers.splice(indexOf, 1);
        }
      };

      // Submit the form in its current state.  This displays all validaion errors on the current form and if the form is valid, performs the operation for the current step.
      vm.migrate = function () {
        vm.isProcessing = true;

        if (vm.isBillingChanged() === false) {
          vm.signup.user.isBillingAccepted = null;
        }

        migrateService.migrate(vm.signup).then(function () {
          Messages.add("success", "Your account has been successfully updated.", {
            showOnNextPage: true
          });
          $location.url("/login");
        }).catch(function (err) {
          console.log('error');
          console.log(err);
        }).finally(function () {
          vm.isProcessing = false;
        });
      };

      vm.reset = function () {
        pcMilerSignedIn(angular.copy(vm.oSignup));
        vm.wizardStep = 0;
      };

      vm.countryChanged = function () {
        var c = _.find(STATES, {
          abbreviation: vm.signup.customer.billing.State
        });
        if (c && c.country !== vm.signup.customer.billing.Country) {
          vm.signup.customer.billing.State = "";
        }
      };

      vm.stateChanged = function () {
        var c = _.find(STATES, {
          abbreviation: vm.signup.customer.billing.State
        });
        if (c && c.country !== vm.signup.customer.billing.Country) {
          vm.signup.customer.billing.Country = c.country;
        }
      };

      vm.isBillingChanged = function () {
        return vm.signup.user.numberOfUsers !== vm.oSignup.user.numberOfUsers || vm.oSignup.user.featureLevel === "Lite" || vm.signup.user.featureLevel !== vm.oSignup.user.featureLevel;
      };

      vm.isOriginalCardValid = function () {
        // if the original card was not valid, or if the card is changed - require the card information to be entered.

        if (vm.oSignup.customer.isInvoiced) {
          return true;
        }

        if (!vm.oSignup.customer.credit) {
          return false;
        }

        if (!vm.oSignup.customer.credit.number) {
          return false;
        }

        if (!vm.oSignup.customer.credit.name) {
          return false;
        }

        if (!vm.oSignup.customer.credit.expMonth) {
          return false;
        }

        if (!vm.oSignup.customer.credit.expYear) {
          return false;
        }

        return true;
      };

      function pcMilerSignedIn(data) {
        if (data.user.featureLevel === "Lite") {
          // Lite is no longer allowed
          data.user.featureLevel = "Standard";
        }

        // try to use the users email as their email, otherwise, use the username.
        data.user.email = data.user.email || data.user.username;

        if (data.user.subUsers) {
          for (var i = 0; i < data.user.subUsers.length; i++) {
            // populate the email field with the email if it exists for the user, otherwise, the username (and let the user correct the "email")
            data.user.subUsers[i].email = data.user.subUsers[i].email || data.user.subUsers[i].username;
          }
        }

        vm.signup = data;

        // todo - set all scope variables for current user.
        if (data.user.ssoExists !== true) {
          // user does not exist in SSO, new user form prepopulated
          vm.signup.user.ssoFirstName = vm.signup.contact == null ? "" : vm.signup.contact.firstName;
          vm.signup.user.ssoLastName = vm.signup.contact == null ? "" : vm.signup.contact.lastName;

          // if the user does not have an ALK SSO user yet, prepopulate the password and confirm password fields for their new user with the pcmiler live password
          vm.signup.user.password = vm.signup.user.pcmPassword;
          vm.signup.user.confirmPassword = vm.signup.user.pcmPassword;
        }
      }

      function loginToSSO() {
        vm.isSSOPasswordValid = true;

        var login = new ALKLogin(vm.signup.user.email, vm.signup.user.password);
        return alkAuthenticationService.validate(login)
          .then(function () {
            vm.wizardStep = 2;

          }).catch(function (err) {
            vm.isSSOPasswordValid = false;
            return $q.reject(err);
          });
      }

      function getUserAccounts() {
        return signupService.getAccounts(vm.signup.user.email).then(function (accounts) {
          vm.userAccounts = [];

          for (var i = 0; i < accounts.data.length; i++) {
            vm.userAccounts.push(accounts.data[i]);
          }

          if (vm.userAccounts.length > 0) {
            delete vm.signup.user.account;
          }
        });
      }

    }]);
})(angular);



// WEBPACK FOOTER //
// ./app/account/migrate.controller.js